import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import "../../../assets/css/gamesCss/Array/insertDelete1D.css"
import GameOverModal from "../../../components/GameOverModal";
import GameWonModal from "../../../components/GameWonModal";
import { useLanguage } from "context/LanguageProvider";
import { useDarkMode } from "../../../context/DarkModeProvider";
import { setGameDone } from "apiHandles/user_progress";


const InsertionDeletion1D = () => {
    const [currentArray, setCurrentArray] = useState([10, 20, 30, 40, 50]);
    const [maxSize, setMaxSize] = useState(8);
    const [score, setScore] = useState(0);
    const [message, setMessage] = useState("");
    const [gameState, setGameState] = useState("playing");
    const [userAnswer, setUserAnswer] = useState([]);
    const [showCorrectAnswer, setShowCorrectAnswer] = useState(false);
    const [operationDetails, setOperationDetails] = useState({});
    const [lives, setLivesLeft] = useState(3);
    const [currentLevel, setCurrentLevel] = useState(0);
    const [challengesCompleted, setChallengesCompleted] = useState(0);

    const [challengesPerLevel] = useState(1);

    const [selectedChallenges, setSelectedChallenges] = useState([]);
    const [currentChallengeIndex, setCurrentChallengeIndex] = useState(0);
    const [challengesForLevel, setChallengesForLevel] = useState([]);
    const [currentChallenge, setCurrentChallenge] = useState(null);
    const [showSuccess, setShowSuccess] = useState(false);
    const [showError, setShowError] = useState(false);
    const [showGameOver, setShowGameOver] = useState(false);
    const [showGameWon, setShowGameWon] = useState(false);
    const { selLanguage } = useLanguage();
    const { darkMode } = useDarkMode();
    const totalInputs = Math.max(maxSize, userAnswer.length + 1);



    const selectedStage = JSON.parse(localStorage.getItem("selectedStage"));
    var games = selectedStage.games;
    var nameGameKey = localStorage.getItem("gameClicked");
    var selectedGame = null;
    for (let i = 0; i < games.length; i++) {
        if (games[i].game_title === nameGameKey) {
            selectedGame = games[i];
            break;
        }
    }

    useEffect(() => {
        if (message) {
            const timer = setTimeout(() => {
                setMessage("");
                setShowError(false);
                setShowSuccess(false);
            }, 2300);
            return () => clearTimeout(timer);
        }
    }, [message]);

    const levelConfigs = {
        0: {
            arraySize: 5,
            maxSize: 8,
            initialArray: [10, 20, 30, 40, 50],
            challenges: {
                insert: [
                    {
                        id: 1,
                        operation: "insert",
                        element: 25,
                        position: 2,
                        description: selLanguage
                            ? "Έστω ότι εισάγετε το στοιχείο 25 στη θέση 2. Δώστε τη νέα μορφή του πίνακα."
                            : "Assume you insert element 25 at position 2. Provide the new form of the array.",
                        complexity: "O(n)",
                        canExecute: true
                    },
                    {
                        id: 2,
                        operation: "insert",
                        element: 60,
                        // 🔼 ΠΙΟ ΔΥΣΚΟΛΟ: εισαγωγή ΜΕΣΑ στον πίνακα, όχι απλά στο τέλος
                        position: 3,
                        description: selLanguage
                            ? "Έστω ότι εισάγετε το στοιχείο 60 στη θέση 3. Δώστε τη νέα μορφή του πίνακα."
                            : "Assume you insert element 60 at position 3. Provide the new form of the array.",
                        complexity: "O(n)",
                        canExecute: true
                    }
                ],
                delete: [
                    {
                        id: 3,
                        operation: "delete",
                        position: 1,
                        description: selLanguage
                            ? "Έστω ότι διαγράφετε το στοιχείο στη θέση 1. Δώστε τη νέα μορφή του πίνακα."
                            : "Assume you delete the element at position 1. Provide the new form of the array.",
                        complexity: "O(n)",
                        canExecute: true
                    },
                    {
                        id: 4,
                        operation: "delete",
                        // 🔼 ΠΙΟ ΔΥΣΚΟΛΟ: διαγραφή εσωτερικού στοιχείου, όχι μόνο του τελευταίου
                        position: 2,
                        description: selLanguage
                            ? "Έστω ότι διαγράφετε το στοιχείο στη θέση 2. Δώστε τη νέα μορφή του πίνακα."
                            : "Assume you delete the element at position 2. Provide the new form of the array.",
                        complexity: "O(n)",
                        canExecute: true
                    }
                ]
            }
        },

        1: {
            arraySize: 7,
            maxSize: 10,
            initialArray: [5, 15, 25, 35, 45, 55, 65],
            challenges: {
                insert: [
                    {
                        id: 5,
                        operation: "insert",
                        element: 20,
                        position: 2,
                        description: selLanguage
                            ? "Εισάγετε το 20 στη θέση 2 (μετατόπιση 5 στοιχείων)"
                            : "Insert 20 at position 2 (shifting 5 elements)",
                        complexity: "O(n)",
                        canExecute: true
                    },
                    {
                        id: 6,
                        operation: "insert",
                        element: 10,
                        position: 0,
                        description: selLanguage
                            ? "Εισάγετε το 10 στην αρχή του πίνακα"
                            : "Insert 10 at the beginning of the array",
                        complexity: "O(n)",
                        canExecute: true
                    },
                    {
                        id: 7,
                        operation: "insert",
                        element: 70,
                        position: 15,
                        description: selLanguage
                            ? "Προσπάθεια εισαγωγής 70 στη θέση 15"
                            : "Attempt to insert 70 at position 15",
                        complexity: "Error",
                        canExecute: false,
                        errorType: selLanguage ? "Υπέρβαση ορίων πίνακα" : "Array index out of bounds"
                    }
                ],
                delete: [
                    {
                        id: 8,
                        operation: "delete",
                        element: 25,
                        description: selLanguage
                            ? "Διαγράψτε το στοιχείο με τιμή 25"
                            : "Delete the element with value 25",
                        complexity: "O(n)",
                        canExecute: true
                    },
                    {
                        id: 9,
                        operation: "delete",
                        position: 0,
                        description: selLanguage
                            ? "Διαγράψτε το πρώτο στοιχείο"
                            : "Delete the first element",
                        complexity: "O(n)",
                        canExecute: true
                    }
                ]
            }
        },

        2: {
            arraySize: 9,
            maxSize: 12,
            initialArray: [12, 24, 36, 48, 60, 72, 84, 96, 108],
            challenges: {
                insert: [
                    {
                        id: 10,
                        operation: "insert",
                        element: 42,
                        position: 3,
                        description: selLanguage
                            ? "Εισάγετε το 42 στη θέση 3 (μετατόπιση 6 στοιχείων)"
                            : "Insert 42 at position 3 (shifting 6 elements)",
                        complexity: "O(n)",
                        canExecute: true
                    },
                    {
                        id: 11,
                        operation: "insert",
                        element: 6,
                        position: 0,
                        description: selLanguage
                            ? "Εισάγετε το 6 στην αρχή (μετατόπιση όλων)"
                            : "Insert 6 at the beginning (shifting all elements)",
                        complexity: "O(n)",
                        canExecute: true
                    },
                    {
                        id: 12,
                        operation: "insert",
                        element: 120,
                        position: 5,
                        description: selLanguage
                            ? "Εισάγετε το 120 στη θέση 5"
                            : "Insert 120 at position 5",
                        complexity: "O(n)",
                        canExecute: true
                    }
                ],
                delete: [
                    {
                        id: 13,
                        operation: "delete",
                        position: 4,
                        description: selLanguage
                            ? "Διαγράψτε το στοιχείο στη θέση 4 (μετατόπιση 4 στοιχείων)"
                            : "Delete the element at position 4 (shifting 4 elements)",
                        complexity: "O(n)",
                        canExecute: true
                    },
                    {
                        id: 14,
                        operation: "delete",
                        element: 72,
                        description: selLanguage
                            ? "Διαγράψτε το στοιχείο με τιμή 72"
                            : "Delete the element with value 72",
                        complexity: "O(n)",
                        canExecute: true
                    },
                    {
                        id: 15,
                        operation: "delete",
                        position: 20,
                        description: selLanguage
                            ? "Προσπάθεια διαγραφής στη θέση 20"
                            : "Attempt to delete at position 20",
                        complexity: "Error",
                        canExecute: false,
                        errorType: selLanguage ? "Άκυρος δείκτης" : "Invalid index"
                    }
                ]
            }
        },

        3: {
            arraySize: 11,
            maxSize: 15,
            initialArray: [7, 14, 21, 28, 35, 42, 49, 56, 63, 70, 77],
            challenges: {
                insert: [
                    {
                        id: 16,
                        operation: "insert",
                        element: 31,
                        position: 4,
                        description: selLanguage
                            ? "Εισάγετε το 31 στη θέση 4 (μετατόπιση 7 στοιχείων)"
                            : "Insert 31 at position 4 (shifting 7 elements)",
                        complexity: "O(n)",
                        canExecute: true
                    },
                    {
                        id: 17,
                        operation: "insert",
                        element: 84,
                        position: 11,
                        description: selLanguage
                            ? "Εισάγετε το 84 στο τέλος"
                            : "Insert 84 at the end",
                        complexity: "O(1)",
                        canExecute: true
                    },
                    {
                        id: 18,
                        operation: "insert",
                        element: 3,
                        position: 0,
                        description: selLanguage
                            ? "Εισάγετε το 3 στην αρχή (μετατόπιση όλων)"
                            : "Insert 3 at the beginning (shifting all elements)",
                        complexity: "O(n)",
                        canExecute: true
                    }
                ],
                delete: [
                    {
                        id: 19,
                        operation: "delete",
                        position: 5,
                        description: selLanguage
                            ? "Διαγράψτε το στοιχείο στη θέση 5 (μετατόπιση 5 στοιχείων)"
                            : "Delete the element at position 5 (shifting 5 elements)",
                        complexity: "O(n)",
                        canExecute: true
                    },
                    {
                        id: 20,
                        operation: "delete",
                        element: 35,
                        description: selLanguage
                            ? "Διαγράψτε το στοιχείο με τιμή 35"
                            : "Delete the element with value 35",
                        complexity: "O(n)",
                        canExecute: true
                    }
                ]
            }
        },

        4: {
            arraySize: 13,
            maxSize: 18,
            initialArray: [3, 9, 15, 21, 27, 33, 39, 45, 51, 57, 63, 69, 75],
            challenges: {
                insert: [
                    {
                        id: 21,
                        operation: "insert",
                        element: 18,
                        position: 2,
                        description: selLanguage
                            ? "Εισάγετε το 18 στη θέση 2 (μετατόπιση 11 στοιχείων)"
                            : "Insert 18 at position 2 (shifting 11 elements)",
                        complexity: "O(n)",
                        canExecute: true
                    },
                    {
                        id: 22,
                        operation: "insert",
                        element: 6,
                        position: 0,
                        description: selLanguage
                            ? "Εισάγετε το 6 στην αρχή (μετατόπιση όλων των 13 στοιχείων)"
                            : "Insert 6 at the beginning (shifting all 13 elements)",
                        complexity: "O(n)",
                        canExecute: true
                    },
                    {
                        id: 23,
                        operation: "insert",
                        element: 81,
                        position: 13,
                        description: selLanguage
                            ? "Εισάγετε το 81 στο τέλος"
                            : "Insert 81 at the end",
                        complexity: "O(1)",
                        canExecute: true
                    }
                ],
                delete: [
                    {
                        id: 24,
                        operation: "delete",
                        position: 6,
                        description: selLanguage
                            ? "Διαγράψτε το στοιχείο στη θέση 6 (μετατόπιση 6 στοιχείων)"
                            : "Delete the element at position 6 (shifting 6 elements)",
                        complexity: "O(n)",
                        canExecute: true
                    },
                    {
                        id: 25,
                        operation: "delete",
                        element: 45,
                        description: selLanguage
                            ? "Διαγράψτε το στοιχείο με τιμή 45"
                            : "Delete the element with value 45",
                        complexity: "O(n)",
                        canExecute: true
                    },
                    {
                        id: 26,
                        operation: "delete",
                        position: 0,
                        description: selLanguage
                            ? "Διαγράψτε το πρώτο στοιχείο (μετατόπιση όλων)"
                            : "Delete the first element (shifting all elements)",
                        complexity: "O(n)",
                        canExecute: true
                    }
                ]
            }
        }
    };


    // 🔁 ΕΠΙΛΟΓΗ ΜΙΑΣ ΤΥΧΑΙΑΣ ΠΡΟΚΛΗΣΗΣ ΑΝΑ ΕΠΙΠΕΔΟ
    const prepareLevelChallenges = () => {
        const levelConfig = levelConfigs[currentLevel];

        if (!levelConfig) {
            console.error("Invalid level configuration for level:", currentLevel);
            return;
        }

        const allLevelChallenges = [
            ...levelConfig.challenges.insert,
            ...levelConfig.challenges.delete
        ];

        const randomChallenge =
            allLevelChallenges[Math.floor(Math.random() * allLevelChallenges.length)];

        setSelectedChallenges([randomChallenge]);
        setCurrentChallengeIndex(0);
        setCurrentChallenge(randomChallenge);
        setOperationDetails(randomChallenge);
        setChallengesForLevel([randomChallenge]);

        setUserAnswer([]);
        setShowCorrectAnswer(false);
        setCurrentArray([...levelConfig.initialArray]);
        setMaxSize(levelConfig.maxSize);
        setMessage("");
        setShowSuccess(false);
        setShowError(false);
    };


    useEffect(() => {
        resetLevel();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentLevel]);

    const resetLevel = () => {
        prepareLevelChallenges();
    };

    // 🔁 ΟΤΑΝ ΘΕΛΟΥΜΕ ΝΕΑ ΠΡΟΚΛΗΣΗ ΣΤΟ ΙΔΙΟ ΕΠΙΠΕΔΟ (σε λάθος απάντηση)
    const generateNewChallenge = () => {
        const levelConfig = levelConfigs[currentLevel];

        if (!levelConfig) {
            console.error("Invalid level configuration for level:", currentLevel);
            return;
        }

        const allLevelChallenges = [
            ...levelConfig.challenges.insert,
            ...levelConfig.challenges.delete
        ];

        const randomChallenge =
            allLevelChallenges[Math.floor(Math.random() * allLevelChallenges.length)];

        setSelectedChallenges([randomChallenge]);
        setCurrentChallengeIndex(0);
        setCurrentChallenge(randomChallenge);
        setOperationDetails(randomChallenge);

        setCurrentArray([...levelConfig.initialArray]);
        setMaxSize(levelConfig.maxSize);
        setUserAnswer([]);
        setShowCorrectAnswer(false);
        setMessage("");
        setShowError(false);
        setShowSuccess(false);
    };

    const executeOperation = (challenge, array) => {
        let newArray = [...array];

        if (challenge.operation === "insert") {
            if (!challenge.canExecute) {
                return { success: false, array: [...array], error: challenge.errorType };
            }

            if (challenge.position > newArray.length || newArray.length >= maxSize) {
                return { success: false, array: [...array], error: selLanguage ? "Δεν είναι δυνατή η εισαγωγή" : "Cannot insert element" };
            }

            newArray.splice(challenge.position, 0, challenge.element);
            return { success: true, array: newArray };

        } else if (challenge.operation === "delete") {
            if (!challenge.canExecute) {
                return { success: false, array: [...array], error: challenge.errorType };
            }

            if (challenge.position !== undefined) {
                if (challenge.position >= newArray.length || challenge.position < 0) {
                    return { success: false, array: [...array], error: selLanguage ? "Άκυρος δείκτης" : "Invalid index" };
                }
                newArray.splice(challenge.position, 1);
            } else if (challenge.element !== undefined) {
                const index = newArray.indexOf(challenge.element);
                if (index === -1) {
                    return { success: false, array: [...array], error: selLanguage ? "Το στοιχείο δεν βρέθηκε" : "Element not found" };
                }
                newArray.splice(index, 1);
            }

            return { success: true, array: newArray };
        }
    };

    const handleUserSubmit = () => {

        if (gameState !== "playing") {
            return;
        }

        if (userAnswer.length === 0 && currentChallenge.canExecute) {
            setMessage(selLanguage ? "Παρακαλώ εισάγετε την απάντησή σας!" : "Please enter your answer!");
            setShowError(true);
            const newLives = lives - 1;
            setLivesLeft(newLives);

            if (newLives <= 0) {
                setGameState("over");
                setShowGameOver(true);
            }
            return;
        }

        const result = executeOperation(currentChallenge, currentArray);

        if (!currentChallenge.canExecute) {
            if (userAnswer.length === 0 || userAnswer.join(",") === currentArray.join(",")) {
                setScore(prev => prev + 20);
                const newChallengesCompleted = challengesCompleted + 1;
                setChallengesCompleted(newChallengesCompleted);
                setMessage(selLanguage ? "Σωστό! Συνέχισε έτσι!" : "Correct! Keep it up!");
                setShowSuccess(true);
                checkLevelProgress(newChallengesCompleted);
            } else {
                const newLives = lives - 1;
                setLivesLeft(newLives);

                if (newLives <= 0) {
                    setMessage(selLanguage ? "Λάθος! Το παιχνίδι τελείωσε!" : "Wrong! Game over!");
                    setShowError(true);
                    setShowCorrectAnswer(true);
                    setTimeout(() => {
                        setGameState("over");
                        setShowGameOver(true);
                    }, 1500);
                } else {
                    setMessage(selLanguage ? "Λάθος! Δεν πειράζει, συνέχισε την καλή προσπάθεια!" : "Wrong! No worries, keep up the good effort!");
                    setShowError(true);
                    setShowCorrectAnswer(true);
                    setTimeout(() => generateNewChallenge(), 3000);
                }
            }
        } else {
            if (userAnswer.join(",") === result.array.join(",")) {
                setScore(prev => prev + 10);
                const newChallengesCompleted = challengesCompleted + 1;
                setChallengesCompleted(newChallengesCompleted);
                setMessage(selLanguage ? "Μπράβο! Σωστή απάντηση!" : "Well done! Correct answer!");
                setShowSuccess(true);
                checkLevelProgress(newChallengesCompleted);
            } else {
                const newLives = lives - 1;
                setLivesLeft(newLives);

                if (newLives <= 0) {
                    setMessage(selLanguage ? "Λάθος απάντηση! Το παιχνίδι τελείωσε!" : "Wrong answer! Game over!");
                    setShowError(true);
                    setShowCorrectAnswer(true);
                    setTimeout(() => {
                        setGameState("over");
                        setShowGameOver(true);
                    }, 1500);
                } else {
                    setMessage(selLanguage ? "Λάθος απάντηση! Συνέχισε την προσπάθεια!" : "Wrong answer! Keep trying!");
                    setShowError(true);
                    setShowCorrectAnswer(true);
                    setTimeout(() => generateNewChallenge(), 3000);
                }
            }
        }
    };

    const checkLevelProgress = (completedCount) => {
        const newCompletedCount = completedCount !== undefined ? completedCount : challengesCompleted;

        if (newCompletedCount >= challengesPerLevel) {
            setMessage(selLanguage ? "Επίπεδο ολοκληρώθηκε!" : "Level completed!");
            setShowSuccess(true);

            setTimeout(() => {
                setCurrentLevel(prevLevel => {
                    if (prevLevel < 4) {
                        setChallengesCompleted(0);
                        return prevLevel + 1;
                    } else {
                        setGameState("won");
                        setShowGameWon(true);
                        return prevLevel;
                    }
                });
            }, 2000);
        } else {
            setTimeout(() => generateNewChallenge(), 3000);
        }
    };

    const handleArrayInput = (index, value) => {
        const newAnswer = [...userAnswer];

        while (newAnswer.length <= index) {
            newAnswer.push("");
        }

        newAnswer[index] = value === "" ? "" : parseInt(value) || "";
        setUserAnswer(newAnswer.filter((_, i) => i < index + 1 || newAnswer[i] !== ""));
    };

    const resetGame = () => {
        setCurrentLevel(0);
        setChallengesCompleted(0);
        setScore(0);
        setLivesLeft(3);
        setGameState("playing");
        setUserAnswer([]);
        setShowCorrectAnswer(false);
        setShowGameOver(false);
        setShowGameWon(false);
        setMessage("");
        setShowSuccess(false);
        setShowError(false);
        setCurrentChallengeIndex(0);
        // Το resetLevel θα κληθεί αυτόματα από το useEffect
    };


    const getCorrectAnswer = () => {
        const result = executeOperation(currentChallenge, currentArray);
        return result && result.success ? result.array : currentArray;
    };

    const renderArray = (array, title, isUserInput = false) => (
        <div style={{ marginBottom: "30px" }}>
            <h4 style={{
                color: darkMode ? "#f1f5f9" : "#201f1fff",
                marginBottom: "15px",
                fontSize: "1.2em",
                textAlign: "center",
                fontWeight: "700"
            }}>
                {title}
            </h4>
            <div style={{
                display: "flex",
                justifyContent: "center",
                flexWrap: "wrap",
                gap: "8px",
                padding: "20px",
                background: isUserInput ? "rgba(59, 130, 246, 0.1)" : "rgba(255, 255, 255, 0.05)",
                borderRadius: "16px",
                border: isUserInput ? "2px dashed #3b82f6" : "2px solid rgba(255, 255, 255, 0.1)"
            }}>
                {isUserInput ? (

                    Array.from({ length: totalInputs }, (_, i) => (
                        <input
                            key={i}
                            type="number"
                            value={userAnswer[i] || ""}
                            onChange={(e) => handleArrayInput(i, e.target.value)}
                            placeholder={i < array.length + 2 ? "?" : ""}
                            disabled={gameState !== "playing"}
                            style={{
                                width: "60px",
                                height: "60px",
                                textAlign: "center",
                                border: "2px solid #475569",
                                borderRadius: "10px",
                                fontSize: "16px",
                                fontWeight: "600",
                                background: userAnswer[i] !== undefined && userAnswer[i] !== ""
                                    ? "rgba(59, 130, 246, 0.2)"
                                    : "rgba(15, 23, 42, 0.6)",
                                color: "white",
                                transition: "all 0.3s ease"
                            }}
                        />
                    ))
                ) : (
                    <>
                        {array.map((item, index) => (
                            <motion.div
                                key={`${title}-${index}`}
                                initial={{ scale: 0.8, opacity: 0 }}
                                animate={{ scale: 1, opacity: 1 }}
                                transition={{ delay: index * 0.05 }}
                                style={{
                                    width: "60px",
                                    height: "60px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    background: "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)",
                                    color: "white",
                                    borderRadius: "10px",
                                    fontWeight: "700",
                                    fontSize: "18px",
                                    boxShadow: "0 4px 12px rgba(59, 130, 246, 0.3)"
                                }}
                            >
                                {item}
                            </motion.div>
                        ))}
                        {array.length < maxSize && (
                            <div style={{
                                width: "60px",
                                height: "60px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                background: "rgba(107, 114, 128, 0.2)",
                                color: "#94a3b8",
                                borderRadius: "10px",
                                border: "2px dashed #475569",
                                fontSize: "12px",
                                fontWeight: "600"
                            }}>
                                {selLanguage ? "κενό" : "empty"}
                            </div>
                        )}
                    </>
                )}
            </div>
            <div style={{
                textAlign: "center",
                marginTop: "10px",
                fontSize: "0.9em",
                color: "#94a3b8",
                fontWeight: "600"
            }}>
                {isUserInput
                    ? selLanguage
                        ? "Εισάγετε τη νέα κατάσταση του πίνακα"
                        : "Enter the new state of the array"
                    : selLanguage
                        ? `Μέγεθος: ${array.length}/${maxSize}`
                        : `Size: ${array.length}/${maxSize}`}
            </div>
        </div>
    );

    return (
        <div className="main-content insDel1DContainer"
            style={{
                background: darkMode ? "linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #101724ff 100%)" : "var(--lightModeGameBackground)"
            }}>

            <GameOverModal
                isVisible={showGameOver}
                onPlayAgain={resetGame}
            />

            <GameWonModal
                isVisible={showGameWon}
                onPlayAgain={resetGame}
            />

            <div className="max-w-7xl mx-auto" style={{ width: "100%", maxWidth: "1100px" }}>
                {/* Header */}
                <div style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "20px",
                    width: "100%"
                }}>
                    <div style={{
                        color: darkMode ? "#fff" : "#1e293b",
                        padding: "12px 24px",
                        borderRadius: "12px",
                        fontWeight: "700",
                        fontSize: "18px",
                        border: darkMode ? "2px solid rgba(255, 255, 255, 0.2)" : "2px solid #1e293b",
                        display: "flex",
                        alignItems: "center",
                        gap: "10px"
                    }}>
                        {selLanguage ? `Επίπεδο ${currentLevel + 1}/5` : `Level ${currentLevel + 1}/5`}
                    </div>
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px"
                    }}>
                        <div style={{
                            display: "flex",
                            gap: "6px",
                            alignItems: "center"
                        }}>
                            {[1, 2, 3].map((heartNum) => (
                                <div
                                    key={heartNum}
                                    style={{
                                        fontSize: "24px",
                                        filter: lives >= heartNum
                                            ? "drop-shadow(0 4px 8px rgba(220, 38, 38, 0.4))"
                                            : "grayscale(100%) opacity(0.3)",
                                        transform: lives >= heartNum ? "scale(1)" : "scale(0.8)",
                                        transition: "all 0.3s ease"
                                    }}
                                >
                                    ❤️
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Challenge Description */}
                <div style={{
                    borderRadius: "20px",
                    background: "linear-gradient(135deg, rgba(59, 130, 246, 0.4), rgba(29, 78, 216, 0.4))",
                    padding: "15px 20px",
                    marginBottom: "20px",
                    color: "white",
                    fontWeight: "600",
                    textAlign: "center",
                    fontSize: "1.05rem"
                }}>
                    {currentChallenge ? currentChallenge.description : selLanguage ? "Φόρτωση προκλήσεων..." : "Loading challenges..."}
                </div>

                {/* Arrays Display */}
                {currentChallenge && (
                    <div style={{
                        background: darkMode ? "rgba(15, 23, 42, 0.6)" : "#fff",
                        borderRadius: "20px",
                        padding: "30px",
                        marginBottom: "20px",
                        backdropFilter: "blur(10px)"
                    }}>
                        {renderArray(currentArray, selLanguage ? "Αρχικός Πίνακας" : "Initial Array")}
                        {renderArray([], selLanguage ? "Η Απάντησή σας" : "Your Answer", true)}
                        {showCorrectAnswer && (
                            <motion.div
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                            >
                                {renderArray(getCorrectAnswer(), selLanguage ? " Σωστή Απάντηση" : " Correct Answer")}
                            </motion.div>
                        )}
                    </div>
                )}

                {showError && (
                    <motion.div
                        initial={{ scale: 0, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        exit={{ scale: 0, opacity: 0 }}
                        style={{
                            background: '#fee2e2',
                            borderRadius: '15px',
                            padding: '20px',
                            marginBottom: '20px',
                            border: '2px solid #dc2626',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: "95%"
                        }}
                    >
                        <p style={{ color: '#991b1b', margin: 0 }}>
                            {message}
                        </p>
                    </motion.div>
                )}

                {/* Success Message */}
                {showSuccess && (
                    <motion.div
                        initial={{ scale: 0, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        exit={{ scale: 0, opacity: 0 }}
                        style={{
                            background: '#d1fae5',
                            borderRadius: '15px',
                            padding: '20px',
                            marginBottom: '20px',
                            border: '2px solid #10b981',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: "95%"
                        }}
                    >
                        <p style={{ color: '#065f46', margin: 0 }}>
                            {selLanguage ? "Συγχαρητήρια! Προχωράς στο επόμενο επίπεδο!" : "Congratulations! You are advancing to the next level!"}
                        </p>
                    </motion.div>
                )}


                {/* Action Buttons */}
                <div style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "20px",
                    flexWrap: "wrap"
                }}>
                    <motion.button
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                        onClick={handleUserSubmit}
                        disabled={gameState !== "playing"}
                        style={{
                            background: "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)",
                            color: "white",
                            padding: "15px 30px",
                            borderRadius: "12px",
                            fontWeight: "600",
                            fontSize: "1.1em",
                            border: "none",
                            cursor: gameState === "playing" ? "pointer" : "not-allowed",
                            boxShadow: "0 8px 25px rgba(16, 47, 185, 0.3)",
                            opacity: gameState === "playing" ? 1 : 0.6
                        }}
                    >
                        {selLanguage ? "Υποβολή Απάντησης" : "Submit Answer"}
                    </motion.button>

                    <motion.button
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                        onClick={resetGame}
                        style={{
                            background: "linear-gradient(135deg, #b91010 0%, #960505 100%)",
                            color: "white",
                            padding: "15px 30px",
                            borderRadius: "12px",
                            fontWeight: "600",
                            fontSize: "1.1em",
                            border: "none",
                            cursor: "pointer",
                            boxShadow: "0 8px 25px rgba(185, 16, 16, 0.3)"
                        }}
                    >
                        {selLanguage ? "Επανεκκίνηση" : "Restart Game"}
                    </motion.button>
                </div>
            </div>

            <style>{`
                @keyframes heartbeat {
                    0%, 100% { transform: scale(1); }
                    50% { transform: scale(1.1); }
                }

                .insDel1DContainer input[type="number"]::-webkit-inner-spin-button,
                .insDel1DContainer input[type="number"]::-webkit-outer-spin-button {
                    -webkit-appearance: none;
                    margin: 0;
                }

                .insDel1DContainer input[type="number"] {
                    -moz-appearance: textfield;
                }

                .insDel1DContainer input[type="number"]:focus {
                    outline: none;
                    border-color: #3b82f6;
                    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.3);
                }

                .insDel1DContainer input[type="number"]::placeholder {
                    color: #64748b;
                    opacity: 0.6;
                }
            `}</style>
        </div>
    );
};

export default InsertionDeletion1D;
